// actionConfig.js
export const ACTION_CONFIG = {
  DEFAULT: ["SEND_INTEREST", "CHAT", "CONTACT", "IGNORE"],
  INTEREST_RECEIVED: ["ACCEPT", "DECLINE", "CONTACT"],
  INTEREST_SENT: ["SEND_REMINDER", "CHAT", "CONTACT"],
  IGNORED: [ "CHAT", "CONTACT","REMOVE_IGNORE"],
  INTEREST_ACCEPTED: ["CHAT", "CONTACT", "IGNORE"],
};
